import React from 'react';
import ImageUploadField from './ImageUploadField';

const emptyCustomField = () => ({ label: '', value: '', type: 'text' });

export function ProjectGalleryField({ value = [], onChange }) {
  const items = Array.isArray(value) && value.length > 0 ? value : [''];

  const updateItem = (index, nextValue) => {
    const nextItems = items.map((item, itemIndex) => (itemIndex === index ? nextValue : item));
    onChange(nextItems);
  };

  const addItem = () => onChange([...items, '']);

  const removeItem = (index) => {
    const nextItems = items.filter((_, itemIndex) => itemIndex !== index);
    onChange(nextItems.length > 0 ? nextItems : ['']);
  };

  return (
    <div className="space-y-3">
      <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-gray-400">
        Gallery Images
      </label>
      {items.map((item, index) => (
        <div
          key={index}
          className="rounded-lg border border-slate-200 p-3 dark:border-white/10"
        >
          <ImageUploadField
            label={`Image ${index + 1}`}
            value={item}
            onChange={(url) => updateItem(index, url)}
          />
          {items.length > 1 ? (
            <button
              type="button"
              onClick={() => removeItem(index)}
              className="mt-2 text-xs font-bold text-red-500"
            >
              Remove image
            </button>
          ) : null}
        </div>
      ))}
      <button
        type="button"
        onClick={addItem}
        className="rounded-lg border border-primary/40 px-3 py-1.5 text-xs font-bold text-primary"
      >
        + Add Image
      </button>
    </div>
  );
}

export function ProjectCustomFieldsField({ value = [], onChange }) {
  const items = Array.isArray(value) && value.length > 0 ? value : [emptyCustomField()];

  const updateItem = (index, field, nextValue) => {
    const nextItems = items.map((item, itemIndex) =>
      itemIndex === index ? { ...item, [field]: nextValue } : item,
    );
    onChange(nextItems);
  };

  const addItem = () => onChange([...items, emptyCustomField()]);

  const removeItem = (index) => {
    const nextItems = items.filter((_, itemIndex) => itemIndex !== index);
    onChange(nextItems.length > 0 ? nextItems : [emptyCustomField()]);
  };

  return (
    <div className="space-y-3">
      <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-gray-400">
        Extra Project Fields
      </label>
      <p className="text-xs text-slate-400 dark:text-gray-500">
        Add fields specific to this project type (e.g. Full Branding, Campaign URL, Analytics Dashboard).
      </p>
      {items.map((item, index) => (
        <div
          key={index}
          className="grid grid-cols-1 gap-2 rounded-lg border border-slate-200 p-3 dark:border-white/10"
        >
          <input
            type="text"
            value={item.label || ''}
            onChange={(e) => updateItem(index, 'label', e.target.value)}
            placeholder="Field label (e.g. Full Branding)"
            className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-primary focus:outline-none dark:border-white/15 dark:bg-[#1a1a1a] dark:text-white"
          />
          <select
            value={item.type || 'text'}
            onChange={(e) => updateItem(index, 'type', e.target.value)}
            className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-primary focus:outline-none dark:border-white/15 dark:bg-[#1a1a1a] dark:text-white"
          >
            <option value="text">Text</option>
            <option value="url">URL</option>
            <option value="image">Image URL</option>
          </select>
          {item.type === 'image' ? (
            <ImageUploadField
              label="Image"
              value={item.value || ''}
              onChange={(url) => updateItem(index, 'value', url)}
            />
          ) : (
            <input
              type="text"
              value={item.value || ''}
              onChange={(e) => updateItem(index, 'value', e.target.value)}
              placeholder={item.type === 'url' ? 'https://example.com' : 'Field value'}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-primary focus:outline-none dark:border-white/15 dark:bg-[#1a1a1a] dark:text-white"
            />
          )}
          {items.length > 1 ? (
            <button
              type="button"
              onClick={() => removeItem(index)}
              className="justify-self-start text-xs font-bold text-red-500"
            >
              Remove field
            </button>
          ) : null}
        </div>
      ))}
      <button
        type="button"
        onClick={addItem}
        className="rounded-lg border border-primary/40 px-3 py-1.5 text-xs font-bold text-primary"
      >
        + Add Field
      </button>
    </div>
  );
}
